import React from 'react'
import IconButton from 'material-ui/IconButton'
import HelpIcon from 'material-ui/svg-icons/action/help'
import ReactTooltip from 'react-tooltip'

const Feature = (props) => (
  <div className='flex justify-between w-100 items-center'>
    <div className='w-10'>
      <ReactTooltip
        place='left'
        multiline
        effect='solid'
        html/>
      <IconButton
        style={{width: 36, height: 36}}
        disableTouchRipple
        iconStyle={{fill: '#DADADA', width: 18, height: 18}}>
        <HelpIcon
          data-tip={`
            <div
              class='pb2 custom-tooltip'>
              ${props.tooltip}
            </div>`}
          hoverColor='#a8a6a6'/>
      </IconButton>
    </div>
    <div className='w-90 pl3'>
      {props.feature}
    </div>
  </div>
)

export default Feature



// WEBPACK FOOTER //
// ./src/routes/ManagePlans/Plans/Feature.js